// extracted by mini-css-extract-plugin
module.exports = {"upcomingEpisode":"fa","comingSoon":"fb","isRental":"fc","startDate":"fd","upcomingTitle":"fe","comingSoonTitle":"ff","startDateTitle":"fh","available":"fi"};